import type { SVGProps } from 'react';
export const CollectionIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    stroke="currentColor"
    fill="none"
    strokeWidth="2"
    viewBox="0 0 113 119"
    height="100%"
    width="100%"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M58.6989 50.5255C58.6989 66.4406 45.7835 79.3441 29.8494 79.3441C13.9154 79.3441 1 66.4406 1 50.5255C1 34.6105 13.9154 21.707 29.8494 21.707C45.7835 21.707 58.6989 34.6105 58.6989 50.5255Z" />
    <path d="M78.7559 57.5902C79.4192 56.4425 81.0759 56.4425 81.7393 57.5902L105.384 98.502C106.048 99.6506 105.219 101.087 103.893 101.087H56.6026C55.276 101.087 54.4471 99.6506 55.1109 98.502L78.7559 57.5902Z" />
    <rect x="67.332" y="1" width="39.4576" height="39.4146" rx="1.72289" />
  </svg>
);
